import { ReactElement } from 'react'

import NavBar from '../NavBar'
import { HeaderWrapper } from './styles'

interface IProps {
  isHeaderTransparent: boolean
}

// eslint-disable-next-line react/display-name
export default function ({ isHeaderTransparent }: IProps): ReactElement {
  return (
    <HeaderWrapper transparent={isHeaderTransparent}>
      <NavBar />
    </HeaderWrapper>
  )
}
